/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Workout_TitleInputs */

const en_us2_quick_workout_title = /** @type {(inputs: Quick_Workout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick workout`)
};

const pt_br2_quick_workout_title = /** @type {(inputs: Quick_Workout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino rápido`)
};

const es_419_quick_workout_title = /** @type {(inputs: Quick_Workout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenamiento rápido`)
};

const pt_pt2_quick_workout_title = /** @type {(inputs: Quick_Workout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino rápido`)
};

const fr_fr2_quick_workout_title = /** @type {(inputs: Quick_Workout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séance rapide`)
};

const de_de2_quick_workout_title = /** @type {(inputs: Quick_Workout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnelltraining`)
};

const it_it2_quick_workout_title = /** @type {(inputs: Quick_Workout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenamento rapido`)
};

/**
* | output |
* | --- |
* | "Quick workout" |
*
* @param {Quick_Workout_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_title = /** @type {((inputs?: Quick_Workout_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_title(inputs)
	if (locale === "es-419") return es_419_quick_workout_title(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_title(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_title(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_title(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_title(inputs)
	return en_us2_quick_workout_title(inputs)
});
export { quick_workout_title as "quick-workout.title" }